/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';

import moment from 'moment';

import Classnames from 'classnames';

import _at from 'lodash/at';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEqual from 'lodash/isEqual';
import _find from 'lodash/find';
import _slice from 'lodash/slice';
import _chunk from 'lodash/chunk';
import _map from 'lodash/map';

import {StubFunc, toHumanDay} from '../../utils';

import {prepareChannels} from '../../utils';
import Translate from '../../components/Translate';
import ViewSlider from '../../components/ViewSlider';
import Grid from '../../components/EPGGrid';

import {GetAllChannelsSortedByFavAndLcn, FetchProgramGuide, AppendProgramGuide, ClearScheduleStore} from './../../actions/schedule/actions-schedule';

class EPGGridPage extends Component {
  constructor(props) {
    super(props);
    let humanDay = toHumanDay();

    this.state = {
      filteredChannels: null,
      isShowGenres: false,
      genres: [],
      limit: _get(this.props, 'metadata.limit', _get(Config, 'epg.epg_container_channels_in_view', 10)) * 2,
      offset: _get(this.props, 'metadata.offset', 0),
      isEnd: false,
      start: _get(this.props, 'matadata.start', humanDay.start),
      end: _get(this.props, 'matadata.end', humanDay.end),
      calendar: [],
      program_guide: []
    };
  }

  componentDidMount() {
    let category = _find(this.props.categories, {extid: _get(Config, 'epg.epg_category')});

    this.props.GetAllChannelsSortedByFavAndLcn({
      category: _get(category, 'id')
    });

    this.setState({
      genres: _get(category, 'genres', [])
    });

    this._createCalendar();
  }

  componentWillReceiveProps(newProps) {

    if (_size(newProps._compareChannelsArray) && !_isEqual(this.props._compareChannelsArray, newProps._compareChannelsArray)) {
      this.setState({
        offset: 0,
        isEnd: !!_size(newProps._compareChannelsArray) && _size(newProps._compareChannelsArray) < this.state.limit
      });

      this.props.FetchProgramGuide(
        _slice(_get(newProps, 'allChannels'), 0, this.state.limit),
        {
          start: _get(this.state, 'start'),
          end: _get(this.state, 'end')
        }
      );
    }

    if (_size(newProps._compareScheduleArray) && !_isEqual(this.props._compareScheduleArray, newProps._compareScheduleArray)) {

      let preparedEpg = prepareChannels(newProps.channels, newProps.program_guide);

      this.setState({
        program_guide: preparedEpg
      });
    }
  }

  componentWillUnmount() {

    this.props.ClearScheduleStore(this.props._compareScheduleArray);
  }

  _createCalendar() {

    let now = moment();
    let calendar = [];
    for (let d = -_get(Config, 'epg.epg_window_prev', 4); d <= _get(Config, 'epg.epg_window_next', 7); d++) {

      calendar.push(now.clone().add(d, 'days').hour(6));
    }

    this.setState({calendar: calendar});
  }

  _tryToAppendNewData() {
    let channelsCollection = _get(this.state, 'filteredChannels') || _get(this.props, 'allChannels');

    if (!this.state.isEnd && !this.props.fetchInProgress && !this.props.appendInProgress && channelsCollection.length) {

      let offset = _get(this.state, 'offset') + _get(this.state, 'limit');

      this.props.AppendProgramGuide(
        _slice(channelsCollection, offset, offset + this.state.limit),
        {
          start: _get(this.state, 'start'),
          end: _get(this.state, 'end')
        }
      );

      this.setState({
        offset: offset,
        isEnd: offset >= _size(channelsCollection)
      });
    }
  }

  _toggleGenres() {

    if (this.state.isShowGenres) {
      this._clearGenre();
    }

    this.setState({isShowGenres: !this.state.isShowGenres});
  }

  _selectGenre(genre) {
    let filteredChannels = this.props.allChannels.filter((channel) => {

      return _map(channel.genres, 'id').indexOf(genre.id) !== -1;
    });

    this.setState({
      offet: 0,
      isEnd: _size(filteredChannels) < this.state.limit,
      filteredChannels: filteredChannels,
      selectedGenre: genre
    });

    this.props.FetchProgramGuide(
      _slice(filteredChannels, 0, this.state.limit),
      {
        start: _get(this.state, 'start'),
        end: _get(this.state, 'end')
      }
    );
  }

  _clearGenre() {
    if (this.state.selectedGenre) {

      this.setState({
        offset: 0,
        isEnd: !!_size(this.props._compareChannelsArray) && _size(this.props._compareChannelsArray) < this.state.limit,
        filteredChannels: null,
        selectedGenre: null
      });

      this.props.FetchProgramGuide(
        _slice(_get(this.props, 'allChannels'), 0, this.state.limit),
        {
          start: _get(this.state, 'start'),
          end: _get(this.state, 'end')
        }
      );
    }
  }

  _selectDay(day) {
    this.props.ClearScheduleStore(this.props._compareScheduleArray);

    let humanDay = toHumanDay(day);

    let channelsCollection = _get(this.state, 'filteredChannels') || _get(this.props, 'allChannels')

    this.setState({
      start: humanDay.start,
      end: humanDay.end,
      limit: _get(this.props, 'metadata.limit', _get(Config, 'epg.epg_container_channels_in_view', 10)) * 2,
      offset: _get(this.props, 'metadata.offset', 0),
      isEnd: !!_size(channelsCollection) && _size(channelsCollection) < this.state.limit
    });

    this.props.FetchProgramGuide(
      _slice(channelsCollection, 0, _get(this.props, 'metadata.limit', _get(Config, 'epg.epg_container_channels_in_view', 10)) * 2),
      {
        start: _get(humanDay, 'start'),
        end: _get(humanDay, 'end')
      }
    );
  }

  _renderGenres() {

    return _chunk(this.state.genres, '4').map((group) => {
      return (<ul>
        {group.map((genre) => {
          let genreClasses = Classnames({
            'select-genre hover': true,
            'color-grey': _get(this.state, 'selectedGenre') && _get(this.state, 'selectedGenre.id') !== genre.id,
            'b': _get(this.state, 'selectedGenre') && _get(this.state, 'selectedGenre.id') === genre.id
          });

          return (<li key={'genre_' + genre.id} onClick={this._selectGenre.bind(this, genre)}><a className={genreClasses} id={'genre_' + genre.id}>{genre.title}</a></li>);
        })}
      </ul>);
    });
  }

  _renderCalendar() {

    return this.state.calendar.map((day, index) => {

      let liClass = Classnames({
        'last': index === this.state.calendar.length - 1,
        'day': true,
        'active': toHumanDay(day).start === this.state.start
      });

      let spanClass = Classnames({
        'now-sign': index === _get(Config, 'epg.epg_window_prev')
      });

      return (
        <div key={day.unix()} className={liClass}>
          <a className="pad-lr hover" onClickCapture={this._selectDay.bind(this, day)}>
              <span className="block-note">
                <strong>
                  <span className={spanClass}>
                    {index === _get(Config, 'epg.epg_window_prev') ? <Translate content="epg.today" /> : day.format(_get(Config, 'epg.epg_calendar_day_format', 'D MMM'))}
                  </span>
                </strong>
                {day.format(_get(Config, 'epg.epg_calendar_date_format', 'ddd'))}
              </span>
          </a>
        </div>
      );
    });
  }

  render() {

    return (<div>
        <div id="epg-header">
          <div>
            { (this.state.isShowGenres) &&
            <div className="genres bg-black radius">
              <a className="ico-close genres-close pointer" onClick={this._toggleGenres.bind(this)}><Translate content="close" /></a>
              {this._renderGenres()}
            </div>
            }
            <div className="blocks-row clearfix">
              <div className="blocks-week block menu block-6 radius bg-black">
                <div className="blocks-week-header radius">
                  <ul className="menu block-3 radius bg-black">
                    <li className="block-1"><a className="pad-lr hover pointer">
                    <span className="icon">
                      <span className="ico ico-days_w current-time"></span>
                    </span>
                    </a></li>
                    <li className="block-1 col-last genres-open">
                      <a className="pad-lr hover pointer" onClick={this._toggleGenres.bind(this)}>
                        <span className="block-note-2 p+">
                          <strong><img alt="" src={`/images/${Config.white_skin ? 'white' : 'black'}/dots.png`} /></strong>
                          <span className="pv-"><Translate content={'genres'} /></span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="block-week-days" id="touchcarousel-days">
                  <ViewSlider
                    contentStyle={{width: this.state.calendar.length * 132 + 'px'}}
                    scrollXTo={(_get(Config, 'epg.epg_window_prev') - 1) * 132 - 60}>
                    {this._renderCalendar()}
                  </ViewSlider>
                </div>
              </div>
              <ul className="h-rmenu menu block col-last">
                {<li className="h-rmenu-col block radius bg-black">
                  <Link to="/rdvr" className="hover rec">
                    <i className="ic ic-rdvr ic-32px"></i>
                    <span className="h-rmenu-count"> {this.props.records.length.toString()} </span>
                  </Link></li>}
                <li className="h-rmenu-col block radius bg-black">
                  <Link to="/notifications" className="hover rem">
                    <i className="ic ic-notification ic-24px"></i>
                    <span className="h-rmenu-count"> {this.props.notifications.length.toString()} </span>
                  </Link></li>
              </ul>
            </div>
          </div>
        </div>
        <Grid
          onYEnd={this._tryToAppendNewData.bind(this)}
          start={this.state.start}
          end={this.state.end}
          fetchInProgress={this.props.fetchInProgress}
          appendInProgress={this.props.appendInProgress}
          schedule={_get(this.state, 'program_guide')}
        />
      </div>
    );
  };
}

EPGGridPage.propTypes = {
  appendInProgress: PropTypes.bool.isRequired,
  fetchInProgress: PropTypes.bool.isRequired,
  categories: PropTypes.array.isRequired,
  channels: PropTypes.array.isRequired,
  program_guide: PropTypes.array.isRequired,
  GetAllChannelsSortedByFavAndLcn: PropTypes.func.isRequired,
  FetchProgramGuide: PropTypes.func.isRequired,
  AppendProgramGuide: PropTypes.func.isRequired,
  ClearScheduleStore: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  notifications: PropTypes.array.isRequired,
  _compareChannelsArray: PropTypes.array.isRequired,
  _compareScheduleArray: PropTypes.array.isRequired
};

EPGGridPage.defaultProps = {
  categories: [],
  channels: [],
  program_guide: [],
  GetAllChannelsSortedByFavAndLcn: StubFunc.bind(this, 'GetAllChannelsSortedByFavAndLcn'),
  FetchProgramGuide: StubFunc.bind(this, 'FetchProgramGuide'),
  AppendProgramGuide: StubFunc.bind(this, 'AppendProgramGuide'),
  ClearScheduleStore: StubFunc.bind(this, 'ClearScheduleStore'),
  records: [],
  notifications: [],
  _compareChannelsArray: [],
  _compareScheduleArray: []
};

const mapStateToProps = ({assets, collections: {allChannelsOrderedByFavAndLcn}, schedule, common: {categories}, npvr: {records}, notifications: {notifications}}) => {

  let allChannels = _at(assets, _get(allChannelsOrderedByFavAndLcn, 'collection', []));
  let channels = _at(assets, _get(schedule, 'program_guide.channels', []));
  let scheduleForGrid = _at(_get(schedule, 'schedule', {}), _get(schedule, 'program_guide.schedule', []));

  return {
    categories,
    allChannels: allChannels,
    channels: channels,
    program_guide: scheduleForGrid,
    appendInProgress: _get(schedule, 'program_guide.appendInProgress', false),
    fetchInProgress: _get(schedule, 'program_guide.fetchInProgress', false),
    records: records.collection,
    notifications: notifications.collection,
    _compareChannelsArray: _get(allChannelsOrderedByFavAndLcn, 'collection', []),
    _compareScheduleArray: _get(schedule, 'program_guide.schedule', [])
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({GetAllChannelsSortedByFavAndLcn, FetchProgramGuide, AppendProgramGuide, ClearScheduleStore}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EPGGridPage);



// WEBPACK FOOTER //
// ./src/containers/Epg/epg.js